export const showLoadingOverlay = (payload) => (
  {
    type: 'SHOW_LOADING_OVERLAY',
    text: payload
  }
);

export const hideLoadingOverlay = (payload) => (
  {
    type: 'HIDE_LOADING_OVERLAY',
    text: payload
  }
);

export const toggleLoadingOverlay = (payload) => (
  {
    type: 'TOGGLE_LOADING_OVERLAY',
    text: payload
  }
);

export const showOrderType = (payload) => (
  {
    type: 'SHOW_ORDER_TYPE',
    show: payload
  }
);

export const changeMode = (payload) =>({
  type: 'CHANGE_MODE',
  mode: payload
});



// WEBPACK FOOTER //
// ./src/redux/actions/display.js